<template>
  <div>
    <div class="headCon flex-row">
      <p>{{ policyName }}</p>
      <img
        @click="back"
        class="backIcon"
        src="@/assets/images/mobile/return.png"
        alt=""
      />
    </div>
    <div class="policyContent" v-html="policyContent.content"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      policyId: "",
      policyName: "",
      policyContent: [],
    };
  },
  created() {
    let policyData = JSON.parse(sessionStorage.getItem("policyData"));
    this.policyId = policyData.policyId;
    this.policyName = policyData.policyName;
    this.getPolicyContent();
  },
  mounted() {},
  methods: {
    back() {
      this.$router.push("/enjoyNoApply");
    },
    getPolicyContent() {
      let url = "/dev-api/sqzd/policy/queryPolicyContent";
      let param = {
        policyId: this.policyId,
      };
      this.$httpApi
        .post(url, param)
        .then((res) => {
          this.policyContent = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang='scss' scoped>
.headCon {
  width: 100%;
  height: 6.25rem;
  background: #36ab60;
  position: relative;
  p {
    width: 100%;
    font-size: 1.375rem;
    color: #fff;
    text-align: center;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    padding: 0 56px;
  }
  .backIcon {
    width: 1.875rem;
    position: absolute;
    top: 22px;
    left: 10px;
  }
}
.policyContent {
  width: 100%;
  padding: 10px;
}
</style>
